import { ShieldCheck, ShoppingBasket, Sprout, Truck, Wrench } from 'lucide-react'

export const ROLES = [
  { key: 'consumer', label: 'Consumer', icon: ShoppingBasket },
  { key: 'creator', label: 'Creator', icon: Sprout },
  /** Only offered in the role switcher when the active vertical is Moves. */
  { key: 'fulfiller', label: 'Fulfiller', icon: Truck },
  { key: 'ops', label: 'Operations', icon: Wrench },
  { key: 'admin', label: 'Admin', icon: ShieldCheck },
]

/**
 * Marketplace roles that may appear in the role switcher for a vertical.
 *
 * `fulfiller` is person-level on the participant, but the switcher only offers it
 * under Moves — FTT / Stays / Thrifts are consumer (+ creator when enrolled) only.
 * A Moves fulfiller on Farm-to-Table therefore sees only Buying (and Selling if enrolled).
 */
export function rolesVisibleInVertical(vertical: string, heldRoles: string[]): string[] {
  return heldRoles.filter((role) => {
    if (role === 'fulfiller') return vertical === 'moves'
    return true
  })
}

export const ROLE_HOME_PATHS: Record<string, string> = {
  consumer: '/consumer',
  creator: '/creator',
  fulfiller: '/fulfiller',
  ops: '/ops/health',
  admin: '/admin',
}
